<template>
  <div id="app"
       v-bind:class="{blueBg: $route.meta.isBlueBg, transHeader : hasTransHeader, isAuthView: $route.meta.isAuthView, isLoggedOut : !$route.meta.isAuthView && !$store.state.user.scope}">

    <boot-loader :loadingMessage="loadingMessage"></boot-loader>
    <div
      v-if="loggedIn && !docked && isOpen"
      v-show="!$route.meta.isAuthView"
      class="app-drawer-overlay"
      @click="toggle(false)"
    ></div>
    <aside v-if="loggedIn" v-show="!$route.meta.isAuthView" class="app-drawer"
           v-bind:class="{open: isOpen, docked: docked, isMobile: !docked}">
      <div class="nav-head">
        <div class="avatar" @click="goToProfile">
          <img v-if="$store.state.user.scope.profile_thumb !== null" :src="$store.state.user.scope.profile_thumb" alt="">
          <span v-else>{{upperTwoInitials}}</span>
        </div>
        <div class="name" v-text="$store.state.user.scope.display_name && $store.state.user.scope.use_display_name ? $store.state.user.scope.display_name:  $store.state.user.scope.firstname"></div>

        <div class="settings-menu" v-if="$store.state.user.scope" ref="settingsMenu">
          <button type="button" class="settings-trigger" ref="settingsTrigger" @click="toggleSettingsMenu">
            <i class="material-icons">settings</i>
          </button>
          <div class="settings-dropdown" ref="settingsDropdown" v-show="menuOpen">
            <div class="menu-user" @click="closeAppMenu(); goToProfile()">
              <div class="avatar avatar--lg">
                <img v-if="$store.state.user.scope.profile_large" :src="$store.state.user.scope.profile_large" alt="">
                <span v-else>{{upperTwoInitials}}</span>
              </div>
              <div class="menu-user-info">
                <div class="menu-user-name" v-text="$store.state.user.scope.display_name && $store.state.user.scope.use_display_name ? $store.state.user.scope.display_name : ($store.state.user.scope.firstname + ' ' + $store.state.user.scope.surname)"></div>
                <div class="menu-user-type" v-if="$store.state.user.scope.diabetes_type && $store.state.user.scope.diabetes_type.diabetes_type" v-text="$store.state.user.scope.diabetes_type.diabetes_type"></div>
              </div>
            </div>
            <hr class="menu-divider">
            <button type="button" class="menu-item" @click="closeAppMenu(); goTo('/dashboard')">
              <i class="material-icons">dashboard</i>{{$t('message.dashboardAppBarText')}}
            </button>
            <button type="button" class="menu-item" v-if="!isHcpView" @click="closeAppMenu(); goTo('/questions?type=MY_QUESTIONS')">
              <i class="material-icons">chat</i>{{$t('message.discussionTabMyQuestions')}}
            </button>
            <button type="button" class="menu-item" @click="closeAppMenu(); goTo('/profile/' + $store.state.user.profile.profile_url)">
              <i class="material-icons">person</i>{{$t('message.labelMyProfile')}}
            </button>
            <button type="button" class="menu-item" @click="closeAppMenu(); goTo('/settings')">
              <i class="material-icons">settings</i>{{$t('message.settingsMenuTitleText')}}
            </button>
            <hr class="menu-divider" v-if="!isHcpView">
            <button type="button" class="menu-item" v-if="!isHcpView" @click="closeAppMenu(); goTo('/add-progress')">
              <i class="material-icons">add</i>{{$t('message.addProgressAppBarText')}}
            </button>
            <button type="button" class="menu-item" v-if="!isHcpView" @click="closeAppMenu(); goTo('/food-diary/')">
              <i class="material-icons">add</i>{{$t('message.foodDiaryAddFoodAppBarText')}}
            </button>
            <hr class="menu-divider" v-if="!isHcpView">
            <button type="button" class="menu-item" v-if="!isHcpView" :class="{disabled: showTestimonial}" @click="closeAppMenu(); goTo('/testimonials')">
              <i class="material-icons">edit</i>{{$t('message.addTestimonialText')}}
            </button>
            <button type="button" class="menu-item" v-if="!isHcpView" @click="closeAppMenu(); goToContact()">
              <i class="material-icons">live_help</i>{{$t('message.labelHelp')}}
            </button>
            <button type="button" class="menu-item" @click="closeAppMenu(); logOut()">
              <i class="material-icons">exit_to_app</i>{{$t('message.logOutText')}}
            </button>
          </div>
        </div>
      </div>

      <nav id="nav">
        <router-link to="/dashboard" class="nav-item" @click.native="closeIfMobile">
          <i class="material-icons nav-icon">{{isHcpView && isHcpUser ? 'home' : 'dashboard'}}</i>
          <span class="nav-text">{{$t('message.dashboardMenuTitleText')}}</span>
        </router-link>

        <router-link v-if="isHcpView" to="/hcp" class="nav-item" @click.native="closeIfMobile">
          <i class="material-icons nav-icon">school</i>
          <span class="nav-text">Education</span>
        </router-link>

        <router-link :to="isHcpView && isHcpUser ? '/life/category/evidence-and-papers' : '/life'"
                     class="nav-item" @click.native="closeIfMobile">
          <i class="material-icons nav-icon">local_florist</i>
          <span class="nav-text">{{isHcpView && isHcpUser ? 'Evidence and Papers' : $t('message.lifestyleMenuTitleText')}}</span>
        </router-link>

        <router-link v-if="isHcpUser && isHcpView" to="/downloads" class="nav-item" @click.native="closeIfMobile">
          <i class="material-icons nav-icon">file_download</i>
          <span class="nav-text">Resources</span>
        </router-link>

        <router-link v-if="!questionsDisabled" to="/questions" class="nav-item" @click.native="closeIfMobile">
          <i class="material-icons nav-icon">{{isHcpView || isHcpUser ? 'textsms' : 'live_help'}}</i>
          <span class="nav-text">{{isHcpView && isHcpUser ? 'Forum' : $t('message.questionsMenuTitleText')}}</span>
        </router-link>
        <div v-else class="nav-item disabled">
          <i class="material-icons nav-icon">{{isHcpView || isHcpUser ? 'textsms' : 'live_help'}}</i>
          <span class="nav-text">{{isHcpView && isHcpUser ? 'Forum' : $t('message.questionsMenuTitleText')}}</span>
        </div>

        <router-link v-if="!isHcpView" to="/food-diary" class="nav-item" @click.native="closeIfMobile">
          <i class="material-icons nav-icon">book</i>
          <span class="nav-text">{{$t('message.foodDiaryMenuTitleText')}}</span>
        </router-link>

        <div class="nav-group">
          <button type="button" class="nav-item nav-toggle" @click="recipesOpen = !recipesOpen">
            <i class="material-icons nav-icon">restaurant</i>
            <span class="nav-text">{{$t('message.recipeMenuTitleText')}}</span>
            <i class="material-icons nav-caret">{{recipesOpen ? 'expand_less' : 'expand_more'}}</i>
          </button>
          <div class="nav-nested" v-show="recipesOpen">
            <router-link to="/recipes/" exact class="nav-item nav-subitem" @click.native="closeIfMobile">
              <i class="material-icons nav-icon">view_carousel</i>
              <span class="nav-text">All Recipes</span>
            </router-link>
            <router-link to="/recipes/favorites/" class="nav-item nav-subitem" @click.native="closeIfMobile">
              <i class="material-icons nav-icon">grade</i>
              <span class="nav-text">Favourites</span>
            </router-link>
            <router-link to="/recipes/search" class="nav-item nav-subitem" @click.native="closeIfMobile">
              <i class="material-icons nav-icon">search</i>
              <span class="nav-text">Search</span>
            </router-link>
            <router-link to="/recipes/generator/" class="nav-item nav-subitem" @click.native="closeIfMobile">
              <i class="material-icons nav-icon">refresh</i>
              <span class="nav-text">Meal Plan Generator</span>
            </router-link>
            <router-link to="/recipes/mealplans/" class="nav-item nav-subitem" @click.native="closeIfMobile">
              <i class="material-icons nav-icon">view_list</i>
              <span class="nav-text">My Meal Plans</span>
            </router-link>
          </div>
        </div>

        <div class="nav-group" v-if="!isHcpView">
          <button type="button" class="nav-item nav-toggle" @click="shopOpen = !shopOpen">
            <i class="material-icons nav-icon">shopping_cart</i>
            <span class="nav-text">{{$t('message.shopMenuTitleText')}}</span>
            <i class="material-icons nav-caret">{{shopOpen ? 'expand_less' : 'expand_more'}}</i>
          </button>
          <div class="nav-nested" v-show="shopOpen">
            <a href="https://shop.lowcarbprogram.com/collections/books" target="_blank"
               class="nav-item nav-subitem" @click="closeIfMobile">
              <i class="material-icons nav-icon">book</i>
              <span class="nav-text">Books</span>
            </a>
          </div>
        </div>

        <router-link v-if="!isHcpView" to="/add-progress" class="nav-item" @click.native="closeIfMobile">
          <i class="material-icons nav-icon">add</i>
          <span class="nav-text">{{$t('message.addProgressMenuTitleText')}}</span>
        </router-link>

        <router-link v-if="!isHcpView && $store.state.user.scope.country.country_id === 41" to="/coaching"
                     class="nav-item" @click.native="closeIfMobile">
          <i class="material-icons nav-icon">school</i>
          <span class="nav-text">{{$t('message.coachingMenuTitleText')}}</span>
        </router-link>

        <router-link v-if="!isHcpUser || !isHcpView" to="/downloads" class="nav-item" @click.native="closeIfMobile">
          <i class="material-icons nav-icon">file_download</i>
          <span class="nav-text">{{$t('message.downloadsMenuTitleText')}}</span>
        </router-link>

        <router-link to="/coaching" class="nav-item" @click.native="closeIfMobile">
          <i class="material-icons nav-icon">sports</i>
          <span class="nav-text">Coaching</span>
        </router-link>

        <router-link v-if="!isHcpView" :to="'/profile/' + $store.state.user.profile.profile_url"
                     class="nav-item" @click.native="closeIfMobile">
          <i class="material-icons nav-icon">person</i>
          <span class="nav-text">{{$t('message.profileMenuTitleText')}}</span>
        </router-link>

        <router-link to="/contact" class="nav-item" @click.native="closeIfMobile">
          <i class="material-icons nav-icon">feedback</i>
          <span class="nav-text">{{$t('message.feedbackMenuTitleText')}}</span>
        </router-link>

        <router-link to="/settings" class="nav-item" @click.native="closeIfMobile">
          <i class="material-icons nav-icon">settings</i>
          <span class="nav-text">{{$t('message.settingsMenuTitleText')}}</span>
        </router-link>

        <router-link v-if="!isHcpView" to="/faq" class="nav-item" @click.native="closeIfMobile">
          <i class="material-icons nav-icon">help</i>
          <span class="nav-text">{{$t('message.faqMenuTitleText')}}</span>
        </router-link>

        <button type="button" v-if="isHcpView || isHcpUser" class="nav-item hcpSwitch"
                :class="{disabled: !isHcpVerified && isHcpView}"
                @click="toggleHcpSwitchModal = true">
          <i class="material-icons nav-icon">swap_horizontal_circle</i>
          <span class="nav-text">{{isHcpView ? $t('message.labelSwitchPatient') : $t('message.labelSwitchHcp')}}</span>
        </button>
      </nav>
      <payment-call-to-action v-if="$store.state.status.payment.paid === false"></payment-call-to-action>
<!--      <provider></provider>-->
    </aside>
    <div v-if="!loading" class="page-content" v-bind:class="{sidebarOpen: isOpen, isMobile: !docked}">

      <!-- LoggedOut Auth View App Bar -->
      <mu-appbar
        v-if="($route.meta.isAuthView && !$route.meta.hideRegisterAppBar)"
        v-bind:class="{appBarClosed: !isOpen, noShadow: $route.meta.hideShadow}"
        align="center">
        <mu-flexbox align="center" justify="center">
          <mu-flexbox-item align="center">
            <img v-if="applicationContext === 'grohealth'" width="26" class="logo" src="~assets/gro-small.png">
            <img v-if="applicationContext === 'lowcarbprogram'" width="200" class="logo"
                 src="static/logos/lcp-logo.svg">
          </mu-flexbox-item>
          <div v-if="showLogOut" class="logout-button" @click="logOut">
            <span>
              <mu-icon value="exit_to_app" />
              Log out
            </span>
          </div>
        </mu-flexbox>
      </mu-appbar>
      <!-- LoggedIn App Bar -->
      <mu-appbar
        v-if="!$route.meta.isAuthView && $store.state.user.scope"
        :title="replaceTitle ? replaceTitle : $route.meta.title  + ($route.meta.hasCustomTitle ? ': ' + externalTitle : '')"
        v-bind:class="{appBarClosed: !isOpen, transparent: $route.meta.isBlueBg}">
        <mu-icon-button
          iconClass="menu-icon material-icons-round"
          icon="menu"
          slot="left"
          @click="toggle(false)"
        />
        <mu-icon-button
          class="animated fadeInRight"
          v-if="$route.meta.isChild"
          icon="chevron_left"
          slot="left"
          @click="goBack($route)"
        />
        <mu-icon
          v-if="(isHcpView || isHcpUser) && isHcpVerified"
          value="swap_horizontal_circle"
          color="#FFF"
          class="mobileHcpSwitch"
          @click="toggleHcpSwitchModal = true"
          slot="right"
        />

        <div slot="right" style="margin-right: 20px;display: flex;align-items:center; ">
          <span class="user-block pointer" @click="goToProfile()" slot="right">{{$store.state.user.scope.use_display_name ? $store.state.user.scope.display_name : $store.state.user.scope.firstname}}</span>

          <mu-avatar
            v-if="$store.state.user.scope.profile_thumb !== null"
            style="margin-left: 12px;border: 2px solid #fff;"
            :size="32"
            :src="$store.state.user.scope.profile_thumb"
            color="white"
            backgroundColor="grey"
            @click="goToProfile"
          >
          </mu-avatar>
          <mu-avatar
            v-else
            class="blue"
            style="margin-left: 12px;border: 2px solid #fff;"
            :size="32"
            color="white"
            backgroundColor="grey"
            @click="goToProfile"
          >
            {{upperTwoInitials}}
          </mu-avatar>

        </div>
        <notifications-panel
          v-if="$store.state.user.scope"
          :visible="isNotificationsPanelVisible"
          @panelHidden="hidePanelFn"
          v-on-clickaway="away"
          slot="right"
          style="margin-right: 20px;"
        ></notifications-panel>
      </mu-appbar>

      <!-- LoggedIn App Bar -->
      <mu-appbar
        v-if="!$route.meta.isAuthView && !$store.state.user.scope"
        :title="$route.meta.title  + ($route.meta.hasCustomTitle ? ': ' + externalTitle : '')"
        v-bind:class="{appBarClosed: !isOpen}">
      </mu-appbar>

      <mu-content-block class="main-content" v-bind:id="$route.meta.id" @scroll.native="handleScroll">
        <hcp-search v-if="isHcpView && isHcpUser"></hcp-search>

        <router-view v-if="$store.state.list.diabetes_types"></router-view>


        <footer class="siteFooter content" style="clear:both">

          <mu-row>
            <mu-col width="25" tablet="25" desktop="25">

            </mu-col>
            <mu-col width="50" tablet="50" desktop="50" align="center">


              <!-- <language-picker></language-picker> -->
              <div>

                {{$t('message.labelMadeWith')}}

                <mu-icon color="#D83E38" :size="12" value="favorite"></mu-icon>
                <span v-if="applicationContext === 'grohealth'">grohealth.com</span>
                <span v-if="applicationContext === 'lowcarbprogram'">lowcarbprogram.com</span> &copy; {{currentYear}}
              </div>
            </mu-col>
            <mu-col width="25" tablet="25" desktop="25">

            </mu-col>
          </mu-row>
        </footer>

      </mu-content-block>
      <paywall v-if="$route.meta.paymentWall && $store.state.status.payment.paid === false" :show="showPaywall"/>
      <hcp-switch-modal v-if="isHcpUser" :open="toggleHcpSwitchModal" @close="closeHcpSwitchModal()"/>
    </div>
  </div>
</template>
<script>

  import config from './config'

  import {directive as onClickaway} from 'vue-clickaway';
  import UserApi from './api/User';
  import ListApi from './api/Lists'
  import GeoApi from "./api/Geo"


  import EventBus from './helpers/EventBus'
  import UserManager from './helpers/UserManager';
  import ProviderApi from './api/Provider'
  import IOManager from './helpers/IOManager'
  import NotificationsPanel from "./components/Notifications/Notifications";
  import AuthenticationManager from './helpers/AuthenticationManager'
  import Provider from './components/Provider/Provider.vue'
  import BootLoader from "./components/BootLoader/BootLoader";
  import Pusher from './helpers/PusherManager';
  import {createPopper} from '@popperjs/core';
  import axios from 'axios'

  axios.defaults.headers.common['applicationContext'] = config.ApplicationContext;

  import HCPMixin from './mixins/HCPMixin';
  import Paywall from "./views/Payment/Paywall/Paywall";
  import LanguagePicker from "./components/LanguagePicker/LanguagePicker";
  import Config from '../config'
  import PaymentCallToAction from "./components/PaymentCTA/PaymentCallToAction";


  //import raygun4js from 'raygun4js'
  import MuTextField from "../node_modules/muse-ui/src/textField/textField";
  import MuContentBlock from "../node_modules/muse-ui/src/contentBlock/contentBlock";
  import HcpSearch from "./components/HCP/Search";
  import HcpSwitchModal from "./components/HCP/SwitchProgram";
  import _ from "lodash";
  import ListsApi from "./api/Lists";

  // raygun4js('enableCrashReporting', true);
  //raygun4js('apiKey', config.RaygunKey);
  // raygun4js('enablePulse', true);


  export default {
    mixins: [
      HCPMixin
    ],
    watch: {
      'connected': function () {
        let self = this;
      },
      '$route': function (from, to) {
        let self = this;
        if (self.$route.name === 'Dashboard') {
          self.getUser();
          self.showPaywall = false;

          if($(window).width() >= 1196) {
            self.docked = true;
            self.isOpen = true;
          }
        } else {
          self.showPaywall = true;
        }

        if (to.name !== 'Subscription') {
          self.checkOnboarding();
        }

        self.initPusher();

        self.replaceTitle = '';

        self.hasTransHeader = self.$route.meta.hasTransHeader;
        self.initializeLifeStyleTransparentHeader();
        if (self.$route.meta.hideLeftNav === true) {
          self.docked = false;
          self.isOpen = false;
        }
        if ($(window).width() <= 1196) {
          if (self.$route.meta.hideLeftNav === true) {
            self.docked = false;
            self.isOpen = false;
          }
        } else {
          if (self.$route.meta.hideLeftNav === true) {
            self.docked = false;
            self.isOpen = false;
          }
        }
      }
    },
    components: {
      HcpSwitchModal,
      HcpSearch,
      MuContentBlock,
      MuTextField,
      LanguagePicker,
      Paywall,
      BootLoader,
      Provider,
      NotificationsPanel,
      PaymentCallToAction
    },
    name: 'app',
    directives: {
      onClickaway: onClickaway,
    },
    data() {
      return {
        toggleHcpSwitchModal: false,
        externalTitle: '',
        replaceTitle: '',
        applicationContext: config.ApplicationContext,
        isLowCarb: Config.ApplicationContext === 'lowcarbprogram',
        hasTransHeader: false,
        isNotificationsPanelVisible: false,
        menuOpen: false,
        recipesOpen: false,
        shopOpen: false,
        connected: true,
        isOpen: false,
        docked: false,
        loading: false,
        loadingMessage: "",
        loader: false,
        pusher: null,
        showTestimonial: false,
        showPaywall: true,
        currentYear: moment().format('YYYY'),
        supportedLocales: [
          {
            name: 'en_gb',
            time: 'en'
          },
          {
            name: 'fr_ca',
            time: 'fr'
          }
        ]
      }
    },
    mounted() {
      let self = this;

      self.checkOnboarding();


      axios.get("https://www.diabetes.co.uk/recipe-platform/api/recipe/utilities/alloptions")
        .then(function (response) {
          self.$store.commit('setRecipeCategories', {
            suitabilities: response.data.suitabilities,
            dietaryTypes: response.data.dietaryTypes,
            cuisines: response.data.cuisines,
            occasions: response.data.occasions,
            categories: response.data.categories,
          })
        });


      if (self.$route.name === 'Dashboard') {
        self.showPaywall = false;
      }

      EventBus.$on('App::triggerPaywall', (data) => {
        self.showPaywall = data;
        self.$forceUpdate();
      });

      self.initializeLifeStyleTransparentHeader();

      self.loadingMessage = self.$t('message.bootloaderConnecting');

      Promise.all([
        GeoApi.geoIp(),
        ListApi.getGettingStartedList(),
        ListApi.getMoodsList(),
        ListsApi.getExternalLoginList()])
        .then((responses) => {
          self.$store.commit('setGeoLocation', responses[0].data);

          self.loadingMessage = self.$t('message.bootloaderDownloadingAssets');
          self.$store.commit('setList', responses[1].data);

          self.loadingMessage = self.$t('message.bootloaderInitializing');
          self.$store.commit('setMoodList', responses[2].data);
          self.$store.commit('setLoginProviders', responses[3].data.providers)
        });


      if (AuthenticationManager.hasToken()) {
        const tokenObject = AuthenticationManager.getToken();
        if (tokenObject.expires < new Date()) {
          AuthenticationManager.refreshAccessToken(tokenObject).then(() => {
            self.loadingMessage = self.$t('message.bootloaderProfile');
            self.getUser();
          });
        } else {
          AuthenticationManager.setToken(tokenObject);
          self.loadingMessage = self.$t('message.bootloaderProfile');
          self.getUser();
        }

      }

      let StatusChecker = new IOManager();
      setInterval(function () {
        StatusChecker.ConnectivityStatusWithAppState(self);
      }.bind(self), 5000);

      EventBus.$on('App::triggerLoading', function () {
        self.loader = true;
      });

      EventBus.$on('App::stopLoading', function () {
        self.loader = false;
      });

      //Add's semi colon to app bar to add custom title after a semi colon
      EventBus.$on('App::setCustomTitle', function (title) {
        self.externalTitle = title;
      });

      EventBus.$on('App::setReplaceTitle', function (title) {
        self.replaceTitle = title;
      });

      EventBus.$on('App::dockerResizerStart', function () {
        self.barDockerListen();
      });

      self.$EventBus.$on('App::_onIdle', function () {
        if (self.loggedIn) {
          //the below values must be the keys for the localisation value
          self.$store.commit('setFlashMessage', {
            type: 'error',
            title: self.$t('message.idleLogoutTitle'),
            body: self.$t('message.idleLogoutBody')
          });

          self.logOut();
        }
      });

      if ($(window).width() <= 1196) {
        if (self.$route.meta.hideLeftNav === true) {
          self.docked = false;
          self.isOpen = false;
        } else {
          self.docked = true;
          self.isOpen = false;
        }
      } else {
        if (self.$route.meta.hideLeftNav === true) {
          self.docked = false;
          self.isOpen = false;
        } else {
          self.docked = true;
          self.isOpen = true;
        }
      }
      if (self.$route.meta.hideLeftNav === true) {
        self.docked = false;
        self.isOpen = false;
      }
      self.barDockerListen();

      document.addEventListener("touchstart", function () {
      }, true);

      // switch program
      EventBus.$on('App::onProgramSwitch', () => {
        self.$store.state.user.scope = "";
        self.loadingMessage = "Switching Program ...";
        setTimeout(function () {
          self.getUser();
        }, 2000);
      });
    },
    beforeDestroy() {
      let self = this;
      document.removeEventListener('click', self.onSettingsOutsideClick, true);
      if (self.settingsPopper) {
        self.settingsPopper.destroy();
        self.settingsPopper = null;
      }
    },
    methods: {
      closeHcpSwitchModal(e) {
        let self = this;
        self.toggleHcpSwitchModal = false;
      },
      getUser() {
        let self = this;
        UserApi.getUser().then(function (response) {
          let user = response.data;
          self.$store.commit('setUser', user);

          let weeks = 2, weekDays = weeks * 7, now = moment();
          if (_.has(self.$store.state.user.scope, 'date_joined')) {
            if (now <= moment(self.$store.state.user.scope.date_joined).add('days', weekDays)) {
              self.showTestimonial = true;
            }
            self.showTestimonial = false;
          }


          axios.get(config.apiUrl + 'user/updateComm/' + response.data.scope.user_id)
            .then(function (response) {
            });


          UserApi.onBoardingStatus()
            .then(function (response) {
              self.$store.commit('setOnBoardingStatus', response.data);
              self.checkOnboarding();
            });

          ProviderApi.getProvider().then(function (response) {
            self.$store.commit('setProvider', response.data);
            self.loading = false;
          });

          // pusher
          self.initPusher();

          const tokenObject = AuthenticationManager.getToken();
          if(!_.has(tokenObject, 'refreshToken')) {
            return;
          }

          // Read payment scope from the current token. Only mint a new token
          // if the existing one has actually expired — previously getUser()
          // refreshed on every call (and getUser runs on mount + every
          // Dashboard visit), which refreshed the token far too often.
          let applyScopeFromToken = function () {
            let jwt = AuthenticationManager.parseJwt();
            if (!jwt) {
              return;
            }
            if (_.includes(jwt.scope, 'standard_tasks')) {
              self.$store.commit('setPaymentStatus', true);
            } else if (_.includes(jwt.scope, 'unsubscribed_tasks')) {
              self.$router.push({
                path: '/subscribe'
              });
            }
          };

          let isExpired = tokenObject.expires && new Date(tokenObject.expires) < new Date();
          if (isExpired) {
            AuthenticationManager.refreshAccessToken(tokenObject).then(applyScopeFromToken);
          } else {
            applyScopeFromToken();
          }
        })
      },
      initPusher() {
        let self = this;

        if (self.loggedIn) {
          let userId = self.$store.state.user.scope.user_id;

          Pusher.unsubscribe('settings_' + userId);
          Pusher.unsubscribe('payment_' + userId);
          Pusher.unsubscribe('profileUpdated_' + userId);
          Pusher.unsubscribe('queueSyncComplete_' + userId);
          Pusher.unsubscribe('subscription_' + userId);

          self.pusher = Pusher.subscribe('payment_' + userId);
          self.pusher.bind('refund', (data) => {
            if (data.refunded === true) {
              self.$store.state.status.payment.paid = false;
              self.showPaywall = true;
              self.$forceUpdate();
            }
          });

          let subscr = Pusher.subscribe('payment_' + userId);
          subscr.bind('cancel', (data) => {
            if (data.cancelled === true) {
              self.$store.state.status.payment.paid = false;
              self.showPaywall = true;
              self.$forceUpdate();
            }
          });

          let bindProfilePicture = Pusher.subscribe('profileUpdated_' + userId);
          bindProfilePicture.bind('profileUpdated', function (data) {
            self.$store.state.user.scope.firstname = data.firstname;
            self.$store.state.user.scope.surname = data.surname;
            self.$store.state.user.scope.display_name = data.display_name;
            self.$store.state.user.scope.use_display_name = data.use_display_name;
            self.$store.state.user.scope.profile_thumb = data.profile_thumb;
            self.$store.state.user.scope.profile_large = data.profile_large;
          });

          let bindSettings = Pusher.subscribe('settings_' + userId)
          bindSettings.bind('onSettingsChange', function (data) {
            if (_.has(data, 'onAccountChange')) {
              let account = data.onAccountChange;
              self.$store.state.user.scope.firstname = account.firstname;
              self.$store.state.user.scope.surname = account.surname;
              self.$store.state.user.scope.display_name = account.surname;
              self.$store.state.user.scope.use_display_name = account.use_display_name;
              self.$store.commit('setAccount', account);
            }

            if (_.has(data, 'onUnitsWebChange')) {
              self.$store.state.user.settings = data.onUnitsWebChange;
            }
          });

          let bindPulseSyncComplete = Pusher.subscribe('queueSyncComplete_' + userId);
          bindPulseSyncComplete.bind('heartRate', (data) => {
            if (data.service === 'STRIIV') {
              self.$toastr.success(`New pulse readings imported from Striiv`);
            }
          });

        }
      },
      barDockerListen() {
        let self = this;
        $(window).resize(function () {
          if ($(window).width() <= 1196) {
            if (self.$route.meta.hideLeftNav === true) {
              self.docked = false;
              self.isOpen = false;
            } else {
              self.docked = true;
              self.isOpen = false;
            }
          } else {
            if (self.$route.meta.hideLeftNav === true) {
              self.docked = false;
              self.isOpen = false;
            } else {
              self.docked = true;
              self.isOpen = true;
            }
          }
        });
      },
      handleScroll: function (e) {
        let self = this;
        self.initializeLifeStyleTransparentHeader();
      },
      initializeLifeStyleTransparentHeader() {
        let self = this;
        self.hasTransHeader = self.$route.meta.hasTransHeader;
        let el = '#' + self.$route.meta.id;
        if (self.hasTransHeader === true) {
          // if has trans and is life
          if (self.$route.name === "LifeStyleArticle") {
            if ($(el).scrollTop() >= $(el).outerHeight() - 64) {
              if (self.hasTransHeader === true)
                self.hasTransHeader = false;
            } else {
              if (self.hasTransHeader === false) {
                self.hasTransHeader = true;
              }
            }
          }
        }
      },
      goTo(path) {
        let self = this;
        self.$router.push({
          path: path
        })
      },
      toggleSettingsMenu() {
        let self = this;
        self.menuOpen ? self.closeAppMenu() : self.openSettingsMenu();
      },
      openSettingsMenu() {
        let self = this;
        self.menuOpen = true;
        self.$nextTick(function () {
          let dropdown = self.$refs.settingsDropdown,
            trigger = self.$refs.settingsTrigger;
          if (!dropdown || !trigger) {
            return;
          }
          // Portal the dropdown to <body> so it escapes the drawer's
          // overflow:hidden + transform clipping, then let Popper place it.
          document.body.appendChild(dropdown);
          self.settingsPopper = createPopper(trigger, dropdown, {
            placement: 'right-start',
            modifiers: [
              {name: 'offset', options: {offset: [0, 8]}},
              {name: 'flip', options: {fallbackPlacements: ['bottom-start', 'left-start']}},
              {name: 'preventOverflow', options: {padding: 8}}
            ]
          });
          document.addEventListener('click', self.onSettingsOutsideClick, true);
        });
      },
      closeAppMenu() {
        let self = this;
        if (!self.menuOpen) {
          return;
        }
        self.menuOpen = false;
        document.removeEventListener('click', self.onSettingsOutsideClick, true);
        if (self.settingsPopper) {
          self.settingsPopper.destroy();
          self.settingsPopper = null;
        }
        // Return the portaled dropdown to its original place so Vue keeps
        // managing it cleanly.
        let dropdown = self.$refs.settingsDropdown,
          menu = self.$refs.settingsMenu;
        if (dropdown && menu && dropdown.parentNode !== menu) {
          menu.appendChild(dropdown);
        }
      },
      onSettingsOutsideClick(e) {
        let self = this,
          dropdown = self.$refs.settingsDropdown,
          trigger = self.$refs.settingsTrigger;
        if (dropdown && dropdown.contains(e.target)) {
          return;
        }
        if (trigger && trigger.contains(e.target)) {
          return;
        }
        self.closeAppMenu();
      },
      closeIfMobile() {
        let self = this;
        if ($(window).width() <= 1196) {
          self.docked = true;
          self.isOpen = false;
        } else {
          self.docked = true;
          self.isOpen = true;
        }
      },
      goToProfile() {
        let self = this;
        if (self.isHcpUser && self.isHcpView) {
          self.$router.push({
            path: `/profile/`
              + self.$store.state.user.profile.profile_url
          });
        } else {
          self.$router.push({
            path: `/profile/` + self.$store.state.user.profile.profile_url + '/progress'
          });
        }
      },
      toggle(flag) {
        this.isOpen = !this.isOpen;
        EventBus.$emit('redraw');
        if ($(window).width() <= 1196) {
          this.docked = false;
        } else {
          this.docked = true;
        }
      },
      logOut() {
        let self = this;

        self.$store.commit('setOnBoardingStatus', {});
        self.$store.commit('setPaymentStatus', {});
        self.$store.commit('setLessons', []);
        self.$store.commit('setUser', {});
        self.$store.commit('setAccount', {});
        self.$store.commit('setBloodGlucoseCard', {});
        self.$store.commit('setBloodPressureCard', {});
        self.$store.commit('setNutritionCard', {});
        self.$store.commit('setWeightCard', {});
        self.$store.commit('setSleepCard', {});
        self.$store.commit('setMedicationCard', {});
        self.$store.commit('setCholesterolCard', {});
        self.$store.commit('setInsulinCard', {});
        self.$store.commit('setKetonesCard', {});
        self.$store.commit('setMoodCard', {});
        self.$store.commit('setCardOrder', {});
        self.$store.commit('setProvider', {});
        self.$store.commit('setMoodCard', {});


        axios.get(config.apiUrl + 'logout/').then(function (response) {
          if (_.has(axios.defaults.headers.common, 'Authorization')) {
            delete axios.defaults.headers.common['Authorization'];
          }

          AuthenticationManager.clearSession();
          self.$router.push({
            name: 'Login'
          })
        });

      },
      goToContact() {
        let self = this;
        self.$router.push({
          name: 'Contact'
        })
      },
      goBack(route) {
        let self = this;
        self.$router.go(-1);
      },
      /**
       * @param url
       * @returns {string|*}
       */
      replaceDashes(url) {
        let urlLength = url.length;
        url = url.split('-').join('.');
        return url;
      },
      upperFirstChar(string) {
        return string.charAt(0) + string.slice(1);
      },
      openNotificationPanel() {
        let self = this;
        self.isNotificationsPanelVisible = true;
      },
      away() {
        let self = this;
        self.isNotificationsPanelVisible = false;
      },
      hidePanelFn() {
        let self = this;
        self.isNotificationsPanelVisible = false;
      },
      checkOnboarding() {
        let self = this;

        if (self.$route.name === 'Subscription' || self.$route.name === 'Payment' || self.$route.name === 'AmendRegistration' || self.$route.name === 'Register') {
          return;
        }

        if (self.$store.state.status.payment.paid === false && self.$route.name !== 'AmendRegistration') {
          self.$router.push({
            name: 'Subscription',
          })
        } else {
          if (!self.isHcpUser) {
            if (
              ((self.$route.name === 'GettingStartedAboutYourself')
                ||
                (self.$route.name === 'GettingStartedYourHealth')
                ||
                (self.$route.name === 'GettingStartedLocation')
                ||
                (self.$route.name === 'GettingStartedGoals')
                ||
                (self.$route.name === 'GettingStartedPersonalise'))
            ) {
            } else {
              if (self.$store.state.status.onboarding.about === false) {
                self.$router.push({
                  name: 'GettingStartedAboutYourself'
                })
              } else {
                if (self.$store.state.status.onboarding.location === false) {
                  self.$router.push({
                    name: 'GettingStartedLocation'
                  })
                } else {
                  if (self.$store.state.status.onboarding.goals === false) {
                    self.$router.push({
                      name: 'GettingStartedGoals'
                    })
                  } else {
                    if (self.$store.state.status.onboarding.personalise === false) {
                      self.$router.push({
                        name: 'GettingStartedPersonalise'
                      })
                    }
                  }
                }
              }
            }
          }
        }
      }
    },
    computed: {
      showLogOut() {
        let routeName = this.$route.name
        return routeName === 'Subscription' || routeName === 'GettingStartedAboutYourself' || routeName === 'GettingStartedYourHealth' || routeName === 'GettingStartedLocation' || routeName === 'GettingStartedGoals' || routeName === 'GettingStartedPersonalise';
      },
      loggedIn() {
        let self = this;
        return _.has(self.$store.state.user, 'scope')
      },
      questionsDisabled() {
        return !this.isHcpVerified && this.isHcpView;
      },
      profileUrl: {
        get() {
          let self = this, url = self.$store.state.user.profile.profile_url;
          url = url.split('-').join('.');
          return url;
        },
        set() {
          let self = this, url = self.$store.state.user.profile.profile_url;
          url = url.split('-').join('.');
          return url;
        }
      },
      upperTwoInitials: {
        get() {
          let self = this;
          return self.$store.state.user.scope.display_name && self.$store.state.user.scope.use_display_name ?
            self.$store.state.user.scope.display_name.toString().charAt(0):
            self.$store.state.user.scope.firstname.charAt(0) + self.$store.state.user.scope.surname.charAt(0);
        }
      }
    }
  }
</script>
<style lang="less">
  footer.siteFooter.content {
    margin-top: 24px;
  }

  .white .mu-badge {
    color: white !important;
  }

  //LowCarb Stylesheet
  @import "../static/sprites/flags/flags.min.css";
  @import "~swal/dist/sweetalert2.css";
  @import "~animate/animate.css";
  @import "~toastr-component/build/toastr.css";
  @import "~material-components/dist/vue-material.css";
  @import "~muse-assets/muse-ui.css";
  @import "~mediumjs/medium.css";
  @import "~croppiejs/croppie.css";
  @import "./styles/getting-started.less";
  @import "./styles/tooltip.css";
  @import "./styles/theme.less";
  @import "./styles/general.css";
  @import "./styles/general.css";

  /* ---- Native left navigation drawer (replaces mu-drawer / mu-list) ---- */
  .app-drawer {
    position: fixed;
    top: 0;
    bottom: 0;
    left: 0;
    width: 256px;
    background-color: #fff;
    box-shadow: 1px 1px 20px -10px #5b617c;
    overflow-x: hidden;
    overflow-y: auto;
    z-index: 99;
    visibility: hidden;
    transform: translate3d(-100%, 0, 0);
    transition: transform .45s cubic-bezier(.23, 1, .32, 1), visibility .45s;
    -ms-overflow-style: none;
    scrollbar-width: none;
  }
  .app-drawer::-webkit-scrollbar {
    display: none;
  }
  .app-drawer.open {
    visibility: visible;
    transform: translate3d(0, 0, 0);
  }

  .app-drawer-overlay {
    position: fixed;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    background: rgba(0, 0, 0, .54);
    z-index: 98;
  }

  /* Circular avatar (replaces mu-avatar) */
  .app-drawer .avatar {
    flex: 0 0 auto;
    display: inline-flex;
    align-items: center;
    justify-content: center;
    width: 28px;
    height: 28px;
    border-radius: 50%;
    overflow: hidden;
    background: #e9e9e9;
    color: #0179d5;
    font-size: 13px;
    font-weight: 600;
    cursor: pointer;
  }
  .app-drawer .avatar img {
    width: 100%;
    height: 100%;
    object-fit: cover;
  }
  .app-drawer .avatar.avatar--lg {
    width: 44px;
    height: 44px;
    font-size: 18px;
  }

  /* Header row with avatar, name and settings gear */
  .app-drawer .nav-head {
    display: flex;
    flex-direction: row;
    justify-content: center;
    align-items: center;
    padding: 21px 0 10px;
  }
  .app-drawer .nav-head .avatar {
    margin: 0 10px 0 7px;
  }
  .app-drawer .nav-head .name {
    margin: 3px 16px 0 0;
    width: 90px;
    font-size: 1.1rem;
    font-weight: 600;
    color: #0179d5;
    white-space: nowrap;
    overflow: auto;
    scrollbar-width: none;
  }
  .app-drawer .nav-head .name::-webkit-scrollbar {
    display: none;
  }

  /* Settings dropdown (replaces mu-icon-menu / mu-menu-item) */
  .app-drawer .settings-menu {
    position: relative;
  }
  .app-drawer .settings-trigger {
    display: inline-flex;
    align-items: center;
    padding: 0;
    border: none;
    background: none;
    cursor: pointer;
  }
  .app-drawer .settings-trigger i {
    color: #0179d5;
    font-size: 21px;
    vertical-align: middle;
  }
  /* The settings dropdown is portaled to <body> (via Popper) so it must be
     styled independently of .app-drawer. Popper sets position/inset inline. */
  .settings-dropdown {
    z-index: 1000;
    min-width: 240px;
    padding: 8px 0;
    background: #fff;
    border-radius: 8px;
    box-shadow: 0 2px 16px rgba(0, 0, 0, .2);
    overflow: hidden;
  }
  .settings-dropdown .avatar {
    flex: 0 0 auto;
    display: inline-flex;
    align-items: center;
    justify-content: center;
    width: 44px;
    height: 44px;
    border-radius: 50%;
    overflow: hidden;
    background: #e9e9e9;
    color: #0179d5;
    font-size: 18px;
    font-weight: 600;
  }
  .settings-dropdown .avatar img {
    width: 100%;
    height: 100%;
    object-fit: cover;
  }
  .settings-dropdown .menu-user {
    display: flex;
    align-items: center;
    padding: 8px 16px 12px;
    cursor: pointer;
  }
  .settings-dropdown .menu-user .menu-user-info {
    margin-left: 12px;
    overflow: hidden;
  }
  .settings-dropdown .menu-user .menu-user-name {
    font-weight: 600;
    color: #333;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
  }
  .settings-dropdown .menu-user .menu-user-type {
    font-size: 12px;
    color: #9b9b9b;
  }
  .settings-dropdown .menu-divider {
    height: 1px;
    margin: 8px 0;
    border: none;
    background: rgba(0, 0, 0, .08);
  }
  .settings-dropdown .menu-item {
    display: flex;
    align-items: center;
    width: 100%;
    padding: 10px 16px;
    border: none;
    background: none;
    font-family: inherit;
    font-size: 1rem;
    color: #5b617c;
    text-align: left;
    cursor: pointer;
  }
  .settings-dropdown .menu-item:hover {
    background: rgba(1, 118, 208, .08);
  }
  .settings-dropdown .menu-item i {
    margin-right: 16px;
    font-size: 22px;
    color: #5b617c;
  }
  .settings-dropdown .menu-item.disabled {
    opacity: .5;
    pointer-events: none;
  }

  /* Navigation list (replaces mu-list / mu-list-item) */
  #nav {
    position: relative;
    margin-top: 0;
    padding: 0 12px 8px;
  }
  #nav .nav-item {
    display: flex;
    align-items: center;
    width: 100%;
    box-sizing: border-box;
    margin: 3px 0;
    padding: 12px 14px;
    border: none;
    border-radius: 12px;
    background: none;
    color: #5b617c;
    font-family: inherit;
    font-size: 1rem;
    font-weight: 500;
    text-align: left;
    text-decoration: none;
    cursor: pointer;
    transition: background-color .2s ease-in-out, color .2s ease-in-out;
  }
  /* muse-ui forces anchors to the primary colour with !important, so the
     nav link colours need !important too to stay neutral until active. */
  #nav .nav-item,
  #nav .nav-item .nav-text {
    color: #5b617c !important;
  }
  #nav .nav-item .nav-icon {
    flex: 0 0 auto;
    width: 24px;
    margin-right: 18px;
    font-size: 24px;
    text-align: center;
    overflow: hidden;
    color: #5b617c;
    transition: color .2s ease-in-out;
  }
  #nav .nav-item .nav-text {
    flex: 1 1 auto;
  }
  #nav .nav-item:hover,
  #nav .nav-item.router-link-active {
    background-color: rgba(1, 118, 208, .1);
  }
  #nav .nav-item:hover,
  #nav .nav-item:hover .nav-text,
  #nav .nav-item.router-link-active,
  #nav .nav-item.router-link-active .nav-text {
    color: #0176d0 !important;
  }
  #nav .nav-item:hover .nav-icon,
  #nav .nav-item.router-link-active .nav-icon {
    color: #0176d0;
  }
  #nav .nav-item.disabled {
    opacity: .6;
    cursor: not-allowed;
  }
  #nav .nav-item.disabled:hover {
    background: none;
  }
  #nav .nav-item.disabled:hover,
  #nav .nav-item.disabled:hover .nav-text {
    color: #5b617c !important;
  }
  #nav .nav-toggle .nav-caret {
    flex: 0 0 auto;
    margin-right: 0;
    margin-left: auto;
    font-size: 20px;
  }
  #nav .nav-subitem {
    padding-left: 28px;
  }
  #nav .nav-subitem .nav-icon {
    font-size: 22px;
  }
  #nav .hcpSwitch {
    margin-top: 30px;
  }

  .logout-button {
    padding: 0 13px 4px;
    border-radius: 8px;
    border: solid 1px rgba(255, 255, 255, 0.18);
    transition: all .2s ease-in-out;
    cursor: pointer;
    &:hover {
      opacity: 0.7;
    }
    span {
      font-size: 1rem;
    }
    i {
      font-size: 1rem;
      vertical-align: middle;
      margin-bottom: 3px;
    }
  }
</style>



// WEBPACK FOOTER //
// App.vue?6cccd3e6